import axios, { AxiosResponse } from 'axios'

const API_URL_NEW = process.env.REACT_APP_API_URL_NEW
const LOCATION_LIST_URL = `${API_URL_NEW}/location/allLocations`
const PRODUCT_GROUP_LIST_URL = `${API_URL_NEW}/product/group/list/all`
const BUYER_WISE_INQUIRY_FINAL_PRICE_URL = `${API_URL_NEW}/offer/buyer-wise-inquiry-final-price`

const locationListApi = (search: any): Promise<any> => {
  return axios
    .get(`${LOCATION_LIST_URL}?page=1&perPage=20&search=${search}`)
    .then((d: AxiosResponse<any>) => d.data)
}

const productGroupListApi = (): Promise<any> => {
  return axios
    .get(PRODUCT_GROUP_LIST_URL, { params: { page: 1, perPage: 1000 } })
    .then((d: AxiosResponse<any>) => d.data)
}

const getBuyerWiseInquiryFinalPrice = (params: {
  mobile_number: string
  product_group_id: string
  destination_location_id: string
  qty: string
}): Promise<any> => {
  return axios
    .get(BUYER_WISE_INQUIRY_FINAL_PRICE_URL, { params })
    .then((d: AxiosResponse<any>) => d.data)
}

export { locationListApi, productGroupListApi, getBuyerWiseInquiryFinalPrice }
